import { tokenManager } from './tokenManager';

export const SHARED_INFRA_READONLY_MESSAGE =
  '目前品牌帳號只能查看共用節點與協議資源，請使用全品牌管理員修改。';

export function canMutateSharedInfra(): boolean {
  if (!tokenManager.getPayload()) return false;
  return tokenManager.getBrandScope() === 'all';
}

export function guardSharedInfraMutation(): boolean {
  return canMutateSharedInfra();
}
